import * as React from 'react';
import { verifyUserAccount } from '../../server/server';
import { useLocation, useNavigate } from 'react-router-dom';
import { redirect } from 'react-router-dom';
import { useUser } from '../../auth/UseUser';
import { useEffect, useState } from 'react';
import { notif } from '../utils/util';
import Loading from '../../utils/Loading';

type Inputs = {
	token: any;
	email: any;
	password: string;
	repeatPassword: string;
};

function VerifyAccount({ ...props }) {
	const useQuery = () => {
		return new URLSearchParams(useLocation().search);
	};
	let query1 = useQuery();
	const navigate = useNavigate();
	const { setUser } = useUser();
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		console.log('open page verify account');
		const email = query1.get('email') ?? '';
		const token = query1.get('token') ?? '';
		verifyAccount(email, token);
	}, []);

	const verifyAccount = async (email: string, token: string) => {
		const data = { email, token };
		const resp = await verifyUserAccount(data);
		if (resp.status == 201) {
			notif('Uspešno ste verifikovali nalog!', 'success');
			navigate('/login');
		} else {
			setLoading(false);
		}
	};

	return (
		<div className='w-full h-screen bg-white overflow-auto blue-small-scroll pb-3'>
			<div className='flex flex-col w-[410px] m-auto items-center '>
				<p className='text-[24px] leading-6 text-greyMedium text-center font-semibold uppercase mt-4  '>Verifikacija naloga</p>
				<div>
					{loading ? (
						<div className='mt-[40px]'>
							<Loading size={40} />
						</div>
					) : (
						<div className='mt-[40px] '>
							<p className='text-[18px]  font-bold text-redError text-center'>Verifikacija neuspesna</p>
							<button
								type='button'
								className='w-full h-[44px] px-2 flex items-center justify-center rounded-md border-2 border-greyLight hover:border-greyMedium bg-white text-[18px] text-greyMedium font-bold cursor-pointer mt-5 '
								onClick={() => {
									navigate('/login');
								}}
							>
								Vrati se na početnu stranu
							</button>
						</div>
					)}
				</div>
			</div>
		</div>
	);
}

export default VerifyAccount;
